module.exports = __webpack_public_path__ + "img/personal-portfolio.bbc7563e.png";